import { PagingList } from "~/components/PagingList/PagingList";
import { SimplePagingList } from "~/components/PagingList/SimplePagingList";
export default PagingList;
export { SimplePagingList };
